import React from 'react';
import { Select, Badge } from 'antd';
import { sendFileEmailContactType } from '../../constants/enums/sendFileEmailContactType';

export const getSignerColor = (index) => {
  switch (index) {
    case 0:
      return '#531dab';
    case 1:
      return '#eb2f96';
    case 2:
      return '#389e0d';
    case 3:
      return '#08979c';
    case 4:
      return '#096dd9';
    case 5:
      return '#7cb305';
    case 6:
      return '#d4b106';
    case 7:
      return '#d48806';
    case 8:
      return '#d46b08';
    case 9:
      return '#d4380d';
    case 10:
      return '#cf1322';
    default:
      return '#1890ff';
  }
};

const getSendFileEmailContactTitle = (type) => {
  switch (type) {
    case sendFileEmailContactType.Me:
      return 'Me';
    case sendFileEmailContactType.Insured:
      return 'Insured';
    case sendFileEmailContactType.InsuredContact:
      return 'Insured Contact';
    case sendFileEmailContactType.InsuranceAgency:
      return 'Insurance Agency';
    case sendFileEmailContactType.Agent:
      return 'Agent';

    default:
      return '';
  }
};

const getOptionName = (emailInfo) => {
  const contactTypeClient = getSendFileEmailContactTitle(emailInfo.contactType);

  const prefix = contactTypeClient + (emailInfo.name ? ' (' + emailInfo.name + ')' : '');

  const optName = (prefix !== '' ? prefix + ': ' : '') + emailInfo.email;

  return optName;
};

const getClientOptionNameWithClientPreffix = (emailInfo) => {
  const optName = getOptionName(emailInfo);

  return emailInfo.signerLabel + '  [ ' + optName + ' ]';
};

export const getRabbitSignClientOptionNameWithClientPreffix = (emailInfo) => {
  const optName = getClientOptionNameWithClientPreffix(emailInfo);

  return (
    <>
      <Badge color={emailInfo.signerColor} /> <span>{optName}</span>
    </>
  );
};

const getRabbitSignClientOption = (emailInfo, alreadySelected) => {
  const optName = getOptionName(emailInfo);

  return (
    <Select.Option value={emailInfo.email} key={emailInfo.signerLabel + emailInfo.email} title={optName}>
      <Badge color={emailInfo.signerColor} /> {optName}
    </Select.Option>
  );
};

export const getRabbitSignClientOptions = (clients, fields) => {
  const selectedFieldEmails = fields.map((f) => f.email);

  const unselectedClients = clients.filter((c) => !selectedFieldEmails.includes(c.email));
  const selectedClients = clients.filter((c) => selectedFieldEmails.includes(c.email));

  return (
    <>
      {unselectedClients.map((emailInfo) => getRabbitSignClientOption(emailInfo))}
      {selectedClients.map((emailInfo) => getRabbitSignClientOption(emailInfo))}
    </>
  );
};

export const getRabbitSignTemplateClientOptionName = (templateSignerInfo, key) => {
  const contactTypeClient = getSendFileEmailContactTitle(templateSignerInfo.contactType);

  const suffix = contactTypeClient ? contactTypeClient + ' (' + templateSignerInfo.email + ')' : templateSignerInfo.email;

  const optName = templateSignerInfo.signerLabel + '  [ ' + suffix + ' ]';

  return (
    <React.Fragment key={key}>
      <Badge color={templateSignerInfo.signerColor} /> {optName}
    </React.Fragment>
  );
};

export const mapRabbitSignField = (field, drawIndex, propsToOverride) => {
  return {
    ...field,
    ...{
      page0YPrevPages: 0,
      drawId: drawIndex,
    },
    ...(propsToOverride ? propsToOverride : {}),
  };
};

export const getNewRabbitSignField = (currentField, drawId, currentFileIndex, currentPageNumber, pageHeightSum, fieldType, currentValue, signer) => {
  return {
    drawId: drawId,
    docNumber: currentFileIndex,
    pageIndex: currentPageNumber - 1,
    x: currentField.x,
    y: currentField.y,
    width: 100,
    height: 30,
    page0YPrevPages: pageHeightSum,
    page0Y: pageHeightSum + currentField.y,
    email: signer.email,
    contactType: signer.contactType,
    fieldType: fieldType,
    currentValue: currentValue,
  };
};
